import React, { PureComponent, ReactNode } from 'react';
import classNames from 'classnames/bind';

import { IProps } from './types/main';
import style from './main.pcss';

class Main extends PureComponent<IProps> {

    cn = classNames.bind(style);

    render(): ReactNode {
        return <div className={this.cn('main', this.props.className)}>{this.props.children}</div>;
    }

}

export default Main;
